import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const dasAppApi = createApi({
  reducerPath: "das-app",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/das-app/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
    "DASApp",
    "DASAppStep1",
    "DASAppStep2",
    "DASAppStep3",
    "DASAppStep4",
    "DASAppStep5",
    "DASAppStep6",
    "DASAppData",
  ],
  endpoints: (builder) => ({
    getDasStep1: builder.query({
      query: (appID) => `${appID}/step1`,
      providesTags: ["DASAppStep1"],
    }),
    saveDasStep1: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step1`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep1"],
    }),
    getDasStep2: builder.query({
      query: (appID) => `${appID}/step2`,
      providesTags: ["DASAppStep2"],
    }),
    saveDasStep2: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step2`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep2"],
    }),
    getDasStep3: builder.query({
      query: (appID) => `${appID}/step3`,
      providesTags: ["DASAppStep3"],
    }),
    saveDasStep3: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step3`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep3"],
    }),
    getDasStep4: builder.query({
      query: (appID) => `${appID}/step4`,
      providesTags: ["DASAppStep4"],
    }),
    addDasStep4: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step4`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep4"],
    }),
    deleteDasStep4: builder.mutation({
      query: ({ appID, id }) => ({
        url: `${appID}/step4/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DASAppStep4"],
    }),
    getDasStep5: builder.query({
      query: (appID) => `${appID}/step5`,
      providesTags: ["DASAppStep5"],
    }),
    addDasStep5: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step5`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep5"],
    }),
    deleteDasStep5: builder.mutation({
      query: ({ appID, id }) => ({
        url: `${appID}/step5/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DASAppStep5"],
    }),
    getDasStep6: builder.query({
      query: (appID) => `${appID}/step6`,
      providesTags: ["DASAppStep6"],
    }),
    saveDasStep6: builder.mutation({
      query: ({ appID, data }) => ({
        url: `${appID}/step6`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DASAppStep6"],
    }),
    getApplicationData: builder.query({
      query: (appID) => `${appID}/application-data`,
      skip: (appID) => !appID,
      providesTags: ["DASAppData"],
    }),
    sendPDF: builder.mutation({
      query: ({ appID, formData }) => ({
        url: `${appID}/send-pdf`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["DASAppData"],
    }),
  }),
});

export const {
  useGetDasStep1Query,
  useSaveDasStep1Mutation,
  useGetDasStep2Query,
  useSaveDasStep2Mutation,
  useGetDasStep3Query,
  useSaveDasStep3Mutation,
  useGetDasStep4Query,
  useAddDasStep4Mutation,
  useDeleteDasStep4Mutation,
  useGetDasStep5Query,
  useAddDasStep5Mutation,
  useDeleteDasStep5Mutation,
  useGetDasStep6Query,
  useSaveDasStep6Mutation,
  useGetApplicationDataQuery,
  useSendPDFMutation,
} = dasAppApi;

export default dasAppApi;
export { dasAppApi };
